import { Zap, ExternalLink, Server } from 'lucide-react';
import { useTranslation } from '../../i18n';
import { KOFI_URL } from '../../constants/external';
import styles from './SupportCard.module.css';

export function SupportCard() {
    const { t } = useTranslation();

    return (
        <div className={styles.card}>
            <h2 className={styles.label}>{t('support.sectionTitle')}</h2>
            <div className={styles.strip}>
                <div className={styles.iconWrap}>
                    <Zap size={32} strokeWidth={1.25} />
                </div>
                <h3 className={styles.title}>{t('support.cardTitle')}</h3>
            </div>
            <p className={styles.body}>{t('support.cardBody')}</p>
            <div className={styles.divider} />
            <div className={styles.infraSection}>
                <div className={styles.infraHeader}>
                    <Server size={13} strokeWidth={1.75} />
                    <span>{t('support.infraTitle')}</span>
                </div>
                <ul className={styles.infraList}>
                    <li>{t('support.infraVercel')}</li>
                    <li>{t('support.infraNeon')}</li>
                    <li>{t('support.infraAzure')}</li>
                    <li>{t('support.infraBrowserbase')}</li>
                </ul>
                <p className={styles.costs}>{t('support.cardCosts')}</p>
            </div>
            <a
                href={KOFI_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.cta}
            >
                {t('support.ctaButton')}
                <ExternalLink size={14} strokeWidth={2} />
            </a>
        </div>
    );
}
